/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Value_HeaderInputs */

const en_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

const fr_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur`)
};

const de_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert`)
};

const it_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore`)
};

const ru_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ценить`)
};

const es_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const zh_cn2_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价值`)
};

const ja_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価値`)
};

const hi_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमत`)
};

const pt_pt2_explorer_info_value_header = /** @type {(inputs: Explorer_Info_Value_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Explorer_Info_Value_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_value_header = /** @type {((inputs?: Explorer_Info_Value_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Value_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_value_header(inputs)
	if (locale === "de") return de_explorer_info_value_header(inputs)
	if (locale === "it") return it_explorer_info_value_header(inputs)
	if (locale === "ru") return ru_explorer_info_value_header(inputs)
	if (locale === "es") return es_explorer_info_value_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_value_header(inputs)
	if (locale === "ja") return ja_explorer_info_value_header(inputs)
	if (locale === "hi") return hi_explorer_info_value_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_value_header(inputs)
	return en_explorer_info_value_header(inputs)
});